/* eslint-disable react/button-has-type */
import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as Menu } from '../../../../_base/layout/assets/layout-svg-icons/menu.svg';
import { ReactComponent as MenuActive } from '../../../../_base/layout/assets/layout-svg-icons/menu_active.svg';
import SearchField from '../SearchField';
import { IAppState } from '../../../store/rootDuck';
import DialogCategories from '../DialogCategories';

const HeaderMobileNavigation = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);

  // useLayoutEffect(() => {
  //   dispatch(categoriesActions.fetchCatalogCategories({}));
  // }, []);

  const clear = () => {
    setSelectedCategoryId(null);
  };


  return (
    <div>
      <div style={{ cursor: 'pointer' }} onClick={() => setOpen(true)}>
        {open ? <MenuActive /> : <Menu />}
      </div>
      {/* <SearchField clear={clear} /> */}
      <DialogCategories
        setSelectedCategoryId={setSelectedCategoryId}
        selectedCategoryId={selectedCategoryId}
        open={open}
        close={() => setOpen(false)}
        clear={clear}
        setSearch={value => console.log(value)}
      />
    </div>
  );
};

export default HeaderMobileNavigation;
